module.exports = __webpack_public_path__ + "nunito-sans-latin-700italic.c7569232f38ac2b1b3211151127b1ed3.woff2";